<!-- Footer com Barra de Progresso e Controles de Navegação -->
<footer class="w-full bg-white">
  <div class="w-full border-b border-gray-200 px-4 py-4 md:px-6">
    <div class="mx-auto flex max-w-7xl items-center justify-between gap-4">
      <button
        type="button"
        [disabled]="!canGoPrevious"
        class="btn-secondary inline-flex items-center gap-2"
        (click)="onPrevious()"
      >
        <i class="bi bi-chevron-left"></i>
        <span>Anterior</span>
      </button>

      <div class="flex items-center gap-2 text-sm text-gray-600">
        <span>Lição {{ currentLesson }} de {{ totalLessons }}</span>
        <span class="text-gray-400">•</span>
        <span>{{ moduleName }}</span>
      </div>

      <button
        type="button"
        [disabled]="!canGoNext"
        class="btn-primary inline-flex items-center gap-2"
        (click)="onNext()"
      >
        <span>Próximo</span>
        <i class="bi bi-chevron-right"></i>
      </button>
    </div>
  </div>

  <div class="mx-auto w-full px-4 py-3 md:px-6">
    <div class="mb-2 flex items-center justify-between gap-4">
      <div class="flex items-center gap-2">
        <span class="text-xs font-medium text-gray-700"
          >Progresso da Lição</span
        >
        <span class="text-xs text-gray-500">{{ progress }}%</span>
      </div>
      <div class="flex items-center gap-2 text-xs text-gray-500">
        <i class="bi bi-clock"></i>
        <span>Tempo restante: {{ remainingTime }}</span>
      </div>
    </div>
    <div class="h-2 w-full rounded-full bg-gray-200">
      <div
        class="h-2 rounded-full bg-[var(--color-primary)] transition-all duration-300"
        [style.width]="progress + '%'"
      ></div>
    </div>
  </div>
</footer>
